module.exports = __webpack_public_path__ + "img/fang.6c872657.png";